"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// const actionType = 'ImpactButtons';
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: "impactButtonContainer ".concat(_style["default"].impactButtonContainer, " text-nowrap")
    }, settings.buttons.map(function (button, index) {
      var buttonNode = /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].impactButton,
        key: index
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn ".concat(button.className, " ").concat(_style["default"].clickButton),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: "icon"
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          width: "15",
          height: "15",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: button.icon.viewBox,
          color: "#fff",
          className: _style["default"].svg
        }, /*#__PURE__*/_react["default"].createElement("g", null, button.icon.paths.map(function (p) {
          return /*#__PURE__*/_react["default"].createElement("path", {
            key: p,
            d: p
          });
        }))), " ".concat(button.label)),
        onClick: function onClick() {
          window.location.href = window.cccisd.boilerplate.url(button.link);
        }
      }));
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: button.type
      }, buttonNode);
    }));
  };
};